// Shared world-space layout for the horizon hoarding (ad ribbon) and the central
// scoreboard panel, so SponsorBoards (in Environment) and Scoreboard (in Level2) line up.
export const HOARD = {
  W: 170,        // ad ribbon width (spans the screen)
  H: 7,          // ad ribbon height
  Y: 2.8,        // shared vertical centre
  Z: -29.8,      // ad ribbon depth (on the horizon)
  PANEL_W: 24,   // central scoreboard width (small — just a score chip)
  PANEL_H: 6.5,  // tucked within the ribbon height
  PANEL_Z: -29.4 // scoreboard sits in front of the ribbon
}
